import { DEFAULT_CLIENT_CAN_VIEW } from "utils/cases/toggleBizViewOnly";

export type DocumentAccessSettingsState = {
  isProtected: boolean;
  password: string;
  showPassword: boolean;
  clientCanView: boolean;
};

export function createDefaultDocumentAccessSettings(): DocumentAccessSettingsState {
  return {
    isProtected: false,
    password: "",
    showPassword: false,
    clientCanView: DEFAULT_CLIENT_CAN_VIEW,
  };
}

export function isDocumentAccessPasswordInvalid(settings: DocumentAccessSettingsState): boolean {
  return settings.isProtected && !settings.password.trim();
}
